module.exports = __webpack_public_path__ + "img/logo-light.7c62c994.png";